import React from 'react';
import { Navbar } from '../components/layout/Navbar';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from './founder/HeroSection';
import { PortraitIntroSection } from './founder/PortraitIntroSection';
import { ExpertiseSections } from './founder/ExpertiseSections';
export function MeetTheFounderPage() {
  return <div className="min-h-screen flex flex-col bg-brand-black" data-id="element-849">
      <Navbar data-id="element-850" />
      <main className="flex-grow pt-[7.25rem]" data-id="element-851">
        <HeroSection data-id="element-852" />
        <PortraitIntroSection data-id="element-853" />
        <ExpertiseSections data-id="element-854" />
      </main>
      <Footer data-id="element-855" />
    </div>;
}